// extracted by mini-css-extract-plugin
export default {"pageWrapper":"page-wrapper-v2_pageWrapper__HH+Za","container":"page-wrapper-v2_container__x+qck","containerNoFooter":"page-wrapper-v2_containerNoFooter__CzL5W"};